var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-surface-shader',{staticClass:"shader",attrs:{"type":"canvas","light":{ambient: '#424242', diffuse: '#212121', draw: false, autopilot: true},"mesh":{segments: 20, slices: 20, width: 2, height: 2}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fafc678","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurfaceShader.vue
// module id = null
// module chunks = 